import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export function Footer() {
  return (
    <footer className="mt-auto border-t border-slate-200 bg-[#F8FAFC] text-slate-600">
      <div className="container-nx grid grid-cols-1 gap-10 py-14 sm:grid-cols-2 lg:grid-cols-4">
        <div className="sm:col-span-2 lg:col-span-1">
          <Logo />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-500">
            A trusted digital ecosystem connecting the Vishwakarma business community.
          </p>
          <p className="mt-4 font-display text-[#2563EB]">Connecting People. Creating Progress.</p>
        </div>
        <div>
          <h4 className="font-head text-sm font-semibold text-[#0B192C]">Explore</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/members" className="text-slate-500 hover:text-[#2563EB]">Members</Link></li>
            <li><Link to="/businesses" className="text-slate-500 hover:text-[#2563EB]">Business Directory</Link></li>
            <li><Link to="/opportunities" className="text-slate-500 hover:text-[#2563EB]">Opportunities</Link></li>
            <li><Link to="/events" className="text-slate-500 hover:text-[#2563EB]">Events</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-head text-sm font-semibold text-[#0B192C]">Community</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/about" className="text-slate-500 hover:text-[#2563EB]">About Us</Link></li>
            <li><Link to="/register" className="text-slate-500 hover:text-[#2563EB]">Join Now</Link></li>
            <li><Link to="/login" className="text-slate-500 hover:text-[#2563EB]">Login</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-head text-sm font-semibold text-[#0B192C]">Get in touch</h4>
          <p className="mt-4 text-sm text-slate-500">
            Have questions about the community? Reach out and a member of our team will help you get started.
          </p>
        </div>
      </div>
      <div className="border-t border-slate-200">
        <div className="container-nx flex flex-col items-center justify-between gap-2 py-5 text-xs text-slate-400 sm:flex-row">
          <span>© {new Date().getFullYear()} Vishwakarma Nexus. All rights reserved.</span>
          <span>Built for the community, by the community.</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
